import React, { FunctionComponent, useState } from "react";
import { MuiThemeProvider, Table } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { useTableStyles } from "../../useTableStyle";
import { useCurrencyStyles } from "../useCurrencyStyles";
import moment from "moment";
import { ThemeProvider } from "@mui/material/styles";

interface currencyProps {
  currencylist: any;
}
const emptyOptions = {
  pagination: false,
  selectableRows: undefined,
  selectableRowsHeader: false,
  print: false,
  search: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

const columns = [
  "Name",
  "Code",
  "Unit",
  "Currency Decimal",
  "Buying Rate",
  "Selling Rate",
  "Updated At",
];

const options = {
  selectableRows: undefined,
  selectableRowsHeader: false,
  rowsPerPage: 10,
  rowsPerPageOptions: [5, 10, 15, 25, 50, 100],
  print: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};
export const CurrencyTable: FunctionComponent<currencyProps> = ({
  currencylist,
}) => {
  const getMuiTheme = useTableStyles();
  const classes = useCurrencyStyles();

  if (currencylist && currencylist.length > 0) {
    return (
      <div className={classes.root1}>
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Currency List"}
              data={
                currencylist &&
                currencylist.map((curr: any) => {
                  return [
                    curr.name,
                    curr.code,
                    curr.currency_unit_name,
                    curr.currency_decimal,
                    curr.currency_buying,
                    curr.currency_selling,
                    moment(curr.updated_at).format("DD-MM-YYYY h:mm:ss a"),
                  ];
                })
              }
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </Table>
      </div>
    );
  } else {
    return (
      <div className={classes.root}>
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Currency List"}
              columns={columns}
              data={[]}
              options={emptyOptions}
            />
          </ThemeProvider>
        </Table>
      </div>
    );
  }
};
